import Settings from '../settings'
import { SERVICE_MESSAGE } from '../constants/serviceMessage';
import { PM_MESSAGE, PM_ACCESS_REQUEST } from '../constants/pm';
import { playAudio } from "../audio/utils";
import config from '../../app.config'

import get from 'lodash/get';
import {PRIVATE_TOKEN_NOTIFICATION} from "../constants/notifications";

const sounds = function soundMiddleware(store) {
    return function (next) {
        return function (action) {

            let settings, state;

            switch(action.type) {

                case PM_MESSAGE:
                    const message = action.message;
                    if (message.payload && message.payload.type == "notification") break;
                    if (message.sender_uid != action.uid) break;
                    settings = new Settings();
    
                    if(settings.get('pm_message_sound')) {
                        state = store.getState();
                        if (!get(state, `pmConversations.${action.uid}.view.maximized`, false)) {
                            playAudio(config.audio_url_prefix + 'when.mp3');
                        }
                    }
                    break;

                case PM_ACCESS_REQUEST:
                    settings = new Settings();
                    if (settings.get('pm_request_sound')) {
                        playAudio(config.audio_url_prefix + 'open-up.mp3');
                    }
                    break;

                case SERVICE_MESSAGE:
                    settings = new Settings();
                    if (action.message.type === 'tip_notification' && settings.get('new_tip_sound')) {
                        state = store.getState();
                        if(state.currentUser.nick === action.message.data.receiver) {
                            playAudio(config.audio_url_prefix + 'cash-register.mp3');
                        }
                    }
                    break;
                    
                case PRIVATE_TOKEN_NOTIFICATION:
                    settings = new Settings();
                    if (settings.get('new_pm_tip_sound')) {
                        playAudio(config.audio_url_prefix + 'cash-register.mp3');
                    }
            }

            return next(action);
        };
    };
};


export default sounds;



// WEBPACK FOOTER //
// ./src/middleware/soundNotifications.js